module.exports = __webpack_public_path__ + "img/invitation_failure_alert@3x.90338fe3.png";